import { FC, useState } from 'react';
import { NudosCareCard } from './NudosCareCard';
import { IBasicProductsCare, IProductsCare, IProductsPerCategory } from '../../../../../types/bussines';
import { LoadingOutlined } from '@ant-design/icons';
import { ResetIcon } from 'assets/images/bussines';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../utils/displayNudosStandardNotifications';
import { getOrganizationInventoryURL } from '../../../../../services/bussines';
import { useParams } from 'react-router-dom';
import { IconBlueDownLoad } from '../../../../../assets/DesignSystem/SVGComponents';
import useOnlyDevelopers from '../../../../../state/setOnlyDevelopers';
import './NudosCareTab.scss';
import { TOOL_STATUS_NAME } from 'types/tools';

interface INudosCareTab {
  productsCare: IProductsCare[];
  careProductsUpdate: (e: IBasicProductsCare[]) => void;
  setDinamicProductList: (e: IBasicProductsCare[]) => void;
  dinamicProductList: IBasicProductsCare[];
  setIsEditable: (e: boolean) => void;
  isEditable: boolean;
  loadingUpdateCare: boolean;
  cancelUpdate: () => void;
  productsPerCategory: IProductsPerCategory[];
}

const NudosCareTab: FC<INudosCareTab> = ({
  productsCare,
  careProductsUpdate,
  setDinamicProductList,
  dinamicProductList,
  setIsEditable,
  isEditable,
  loadingUpdateCare,
  cancelUpdate,
  productsPerCategory
}: INudosCareTab) => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { isOnlyDevsLogistics } = useOnlyDevelopers();

  const [loadingDownLoad, setLoadingDownLoad] = useState<boolean>(false);

  /**
   * Registra los cambios del producto; las fechas solo se conservan con el flag logístico activo.
   */
  const handleEditProductsCare = (updatedProduct: IBasicProductsCare) => {
    const payload = isOnlyDevsLogistics
      ? updatedProduct
      : { productId: updatedProduct.productId, nudosCare: updatedProduct.nudosCare };

    const existingIndex = dinamicProductList.findIndex(element => element.productId === payload.productId);

    if (existingIndex >= 0) {
      const updatedList = [...dinamicProductList];
      updatedList[existingIndex] = { ...updatedList[existingIndex], ...payload };
      setDinamicProductList(updatedList);
      return;
    }

    setDinamicProductList([...dinamicProductList, payload]);
  };

  /**
   * Persiste los cambios aplicando el payload según el flag logístico activo.
   */
  const saveCare = () => {
    if (!isOnlyDevsLogistics) {
      careProductsUpdate(
        dinamicProductList.map(({ productId, nudosCare }) => ({
          productId,
          nudosCare
        }))
      );
      return;
    }

    careProductsUpdate(dinamicProductList);
  };

  const handleToggleEditMode = () => {
    if (!isEditable) {
      const editModeMessage = isOnlyDevsLogistics ? (
        <>Ahora puedes editar el plan Care Full y la vigencia de los seriales</>
      ) : (
        <>Ahora puedes edita los planes de Nudos care de los seriales </>
      );

      displaySuccessNotification({ customJSXMessage: editModeMessage });
      setIsEditable(true);
      return;
    }

    if (dinamicProductList?.length > 0) saveCare();
  };

  const productsPerCategoryList = productsPerCategory?.map((item, index) => {
    return (
      <span key={`product-per-category-${item.category}-${index}`}>{`${item.numberOfTools} ${item.category} ${index + 1 !== productsPerCategory.length ? '/' : ''} `}</span>
    );
  });

  const downLoadAction = async () => {
    if (loadingDownLoad) return;
    setLoadingDownLoad(true);
    try {
      const filters = JSON.stringify([
        {
          name: 'toolStatus',
          values: [
            TOOL_STATUS_NAME.AVAILABLE,
            TOOL_STATUS_NAME.DAMAGED,
            TOOL_STATUS_NAME.WAREHOUSE,
            TOOL_STATUS_NAME.WARRANTY,
            TOOL_STATUS_NAME.DIAGNOSTIC,
            TOOL_STATUS_NAME.IN_MOVEMENT
          ]
        }
      ]);
      const urlResume = await getOrganizationInventoryURL(organizationId, filters);
      if (urlResume) window.open(urlResume, '_blank');
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoadingDownLoad(false);
    }
  };

  const renderHeaderActions = () => (
    <>
      <div className="saveButton" onClick={handleToggleEditMode}>
        {loadingUpdateCare ? (
          <>
            <LoadingOutlined />
          </>
        ) : (
          <> {isEditable ? 'Guardar' : 'Editar'}</>
        )}
      </div>
      {!loadingUpdateCare && (
        <div
          className={`cancelIcon ${isEditable ? 'enabledResetButton' : 'disabledResetButton'}`}
          onClick={() => {
            if (isEditable) {
              if (dinamicProductList.length > 0) {
                cancelUpdate();
              } else {
                setIsEditable(false);
              }
            }
          }}
        >
          <ResetIcon stroke={!isEditable ? '#CCCCCC' : ''} />
        </div>
      )}
    </>
  );

  return (
    <div id="nudosCareTab" className={isOnlyDevsLogistics ? 'careLogisticsEnabled' : ''}>
      <div className="titleCare">
        Devices en inventario
        {!loadingDownLoad && (
          <div className="downLoadResume" onClick={downLoadAction}>
            Descargar
            <IconBlueDownLoad />
          </div>
        )}
        {loadingDownLoad && <div className="inputSkeletonLoader animationLoader" />}
      </div>
      <span className="subtitleDevices">{`${productsCare && (productsCare?.length || 0)} devices - `}</span>
      {productsPerCategory && productsPerCategory.length > 0 && (
        <span className="styleTextDevices">{productsPerCategoryList}</span>
      )}
      <div className="headerCare">
        <div className="toolName">Herramientas</div>
        <div className="careName">{isOnlyDevsLogistics ? 'Care Full' : 'Nudos Care'}</div>
        <div className="headerCareSpacer" />
        <div className="headerCareActions">{renderHeaderActions()}</div>
      </div>
      <div className="containerDevices">
        {productsCare &&
          productsCare.length > 0 &&
          productsCare.map(item => {
            return (
              <NudosCareCard
                key={`product-care-${item.productId}`}
                dataCareCard={item}
                isEditable={isEditable}
                handleEditProductsCare={handleEditProductsCare}
                isCareLogisticsEnabled={isOnlyDevsLogistics}
              />
            );
          })}
      </div>
    </div>
  );
};
export default NudosCareTab;
